import { parseGeographicPoint } from '../shared/geographic-point.js';
import type { DataFeature, DataLayer } from '../shared/data-layer.js';
import { dataFeatureSourceName } from '../shared/data-layer-display.js';
import { isString } from '../shared/runtime-values.js';
import type { MarkerDetails } from './marker-details.js';

/** Only published text fields enter the location card; no reverse lookup is needed. */
export function dataMarkerDetails(feature: DataFeature, layer: DataLayer): MarkerDetails[] {
  if (feature.geometry?.type !== 'Point') return [];
  const point = parseGeographicPoint({ lng: feature.geometry.coordinates[0], lat: feature.geometry.coordinates[1] });
  if (!point) return [];
  const fields = new Map(Object.entries(feature.properties).map(([key, value]) => [key.toLowerCase().replace(/[ _-]/g, ''), value]));
  const text = (...names: string[]) => {
    for (const name of names) {
      const value = fields.get(name);
      if (isString(value) && value.trim()) return value.trim();
    }
    return undefined;
  };
  const address = text('formatted', 'fulladdress', 'address') || [text('streetaddress', 'street', 'address1'), text('city', 'town'), text('postcode', 'postalcode', 'zip'), text('country')].filter(Boolean).join(', ') || undefined;
  return [{ id: `${layer.id}:${feature.id}`, point, name: dataFeatureSourceName(feature, layer) ?? undefined, address, note: text('note', 'notes', 'description') }];
}
